import { findIconSource, generateIconFileName } from '../../utils/commonUtils';

const short = require('short-uuid');

export const doesSameSensorExist = (name, clusterlets, sensorId) => {

    let status = true;

    status = clusterlets.find(clusterlet => {
        return clusterlet.name == name && clusterlet.type == 4 && clusterlet.id !== sensorId;
    });



    return status == null ? true : false;
}

/** Create a sensor Object */
export const createSensor = (name,description, position = {}, icon) => {

    return {
        name:name,
        id: short.generate(),
        type: 4,
        position: {
            x: position?.x ? position.x : 2.006799283629652,       
            y: position?.y ? position.y : 54.81031261181564
        },
        attributes: {
            desc: description
        },
        icon: generateIconFileName(icon),
        iconSource: findIconSource(icon),
    }
}